import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const isAuthenticated = createSelector(
  (state: RootState) => state.user,
  user => !!user?.email,
)
